import { render, staticRenderFns } from "./tenantDetail.vue?vue&type=template&id=19520caa&scoped=true"
import script from "./tenantDetail.vue?vue&type=script&lang=js"
export * from "./tenantDetail.vue?vue&type=script&lang=js"
import style0 from "./tenantDetail.vue?vue&type=style&index=0&id=19520caa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19520caa",
  null
  
)

export default component.exports